<template>
  <div class="seciton-information">
    <!--<div class="seciton-information__title">-->
      <!--<img src="@/assets/images/loto/ticket.png"/>-->
      <!--<label>YOUR SELECTION</label>-->
    <!--</div>-->
    <!--<div class="seciton-information__info">-->
      <!--<div-->
          <!--v-for="(item, index) in information"-->
          <!--:key="index"-->
          <!--class="seciton-information__item"-->
      <!--&gt;-->
        <!--<div class="info-title">{{ item.title }}</div>-->
        <!--<div class="info-content">{{ item.value}}</div>-->
      <!--</div>-->
    <!--</div>-->
    <div class="seciton-information__qr-code">
      <button @click="handleGenerateCode">Generate QR Code</button>
    </div>
    <QrCodeModal
            :code="qrCode"
    />
  </div>
</template>

<script>
import { information } from '@/resources/information';
import lottoService from '@/services/lotto.service';
// import QrcodeVue from 'qrcode.vue';
import QrCodeModal from "@/components/common/modal/qr-code-modal";

export default {
  data() {
    return {
      information,
      qrCode: ''
    }
  },
  components:{
    QrCodeModal
    // QrcodeVue
  },
  methods: {
    handleGenerateCode() {
      if (this.$store.state.isLoggedIn) {
        if (this.$store.state.tickets.length) {
          lottoService.generateCode(this.$store.state.type, this.$store.state.tickets).then((res) => {
                if (res.status === 'success') {
                  this.qrCode = res.data.qr.code;

                  // this.$refs['qrcode-modal'].show();
                  this.$bvModal.show('modal-center');
                  // this.$bvToast.toast('Generated successfully ' + qr, {
                  //   title: 'Successfully',
                  //   variant: 'success',
                  //   solid: true,
                  //   autoHideDelay: 5000
                  // });
                } else {
                  const message = res.message;
                  this.$bvToast.toast(message, {
                    title: 'Failed',
                    variant: 'danger',
                    solid: true,
                    autoHideDelay: 5000
                  })
                }
              },
              () => this.$bvToast.toast('Generate Code Failed!', {
                title: 'Failed',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000
              }));
        } else {
          this.$bvToast.toast("Please select tickets", {
            title: 'Failed',
            variant: 'danger',
            solid: true,
            autoHideDelay: 3000
          });
        }
      } else {
        this.$router.push('login');
      }
    }
  }
}
</script>
